// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"304":"fac8f6b138eb54907980","350":"22f3245fb461b86de910","540":"4701a1b37554c5254e40","541":"839245273a4244d4658a","647":"e16c921681259c41e3c6","961":"b25c95beac50c2635daa"}[chunkId] + ".js";
};